import { render, staticRenderFns } from "./ChildBornToSelect.vue?vue&type=template&id=00fb4fee"
import script from "./ChildBornToSelect.vue?vue&type=script&lang=js"
export * from "./ChildBornToSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports